// BUNDLED: pdp-bundle.js
export default function() {
$(function () {

	CCRZ.pubSub.once('view:productDetailView:constructed', function (viewProto) {
		var tabTemplateScript = $("#ProductDetail-CMSTabTemplate").html();
		var tabTemplate = Handlebars.compile(tabTemplateScript);
		$('#PDP-CMSTabs').html(tabTemplate());
		populateTabLabels();
		populateTabContent();
	});	
});
var tabsHavingContent = [];
var tabIdDivMap = new Map();
var tabsToProcess = 4;
tabIdDivMap.set('tabs-1', '#overviewDiv');
tabIdDivMap.set('tabs-2', '#specificationsDiv');
tabIdDivMap.set('tabs-3', '#sustainabilityDiv');
tabIdDivMap.set('tabs-4', '#assemblyInstructionsDiv');
function populateTabLabels() {
	$('#overviewTab a').text(CCRZ.pageLabelMultiString('ProductDetails_Tab_Title_1', 0).string);
	$('#specificationsTab a').text(CCRZ.pageLabelMultiString('ProductDetails_Tab_Title_2', 0).string);
	$('#sustainabilityTab a').text(CCRZ.pageLabelMultiString('ProductDetails_Tab_Title_3', 0).string);
	$('#assemblyInstructionsTab a').text(CCRZ.pageLabelMultiString('ProductDetails_Tab_Title_4', 0).string);
}
function populateTabContent() {
	let productId = CCRZ.productDetailModel.attributes.product.prodBean.id;
	const cmsRemote = _.extend(CCRZ.RemoteInvocation, {className: 'B2C_ProductDetailPageController'});
	cmsRemote.invokeCtx('getCMSData', productId, function (resp, evt) {
			if (evt.status) {
				if (resp && resp.success) {
					if (resp.data.length > 1) {

						let lProductInfo = resp.data[0];
						let lCMSConn = resp.data[1];

						if (lProductInfo && lCMSConn) {
							let lTabs = [];
							lTabs.push({Id: "tabs-1", Category: "Features"});
							lTabs.push({Id: "tabs-2", Category: "Specifications"});
							lTabs.push({ Id: "tabs-3", Category: "Sustainability" });
                            lTabs.push({ Id: "tabs-4", Category: "Installation" });
							lTabs.forEach(function (lTabData) {
								let lURL = getCMSTabURL(lTabData.Category, lCMSConn, lProductInfo);
								if (lURL) {
									 populateCMSContent(lTabData.Id, lCMSConn, lURL,lTabs[lTabs.length - 1].Id);
								}
							});
						}
					}
				}
			}
		},
		{
			buffer: false,
			nmsp: false
		});
}

function getCMSTabURL(tabCategory, cmsConnection, productInfo) {
	if (cmsConnection) {
		if (productInfo) {
			var lURL = cmsConnection.CMS_URL__c + '/wp-json/wp/v2/posts?_embed&status=private,publish';
			lURL += '&filter[category_name]=' + tabCategory;
			lURL += '&filter[tag]=' + productInfo.STEX_CMS_Product_Tag__c;
			return lURL;
		}
	}
	return null;
}

function populateCMSContent(tabId, cmsConnection, URL,lastIndexedTabArrayElementId) {
	jQuery.ajax({
		url: URL,
		type: 'GET',
		beforeSend: function (xhr) {
			if (cmsConnection) {
				var lToken = cmsConnection.Token__c;
				if (lToken) {
					if (lToken.length > 0) {
						xhr.setRequestHeader('Authorization', 'Bearer ' + lToken);
					}
				}
			}
		},
		success: function (response) {
			var lData = {};
			if (response) {
				if (response[0]) {
					lData.Content = response[0].content.rendered;
				}
			}
			if (lData.Content) {
				var lTemplateScript = $("#ProductDetail-CMSTabContent").html();
				var lTemplate = Handlebars.compile(lTemplateScript);
				var lCompiledHtml = lTemplate(lData);
				$('#' + tabId).html(lCompiledHtml);
				$(`.tabsHR`).removeClass('hidden');
				tabsHavingContent.push(tabId);
			} else {
				if (tabId === 'tabs-1') {
					$('#overviewDiv').addClass('hidden');
				}
				else if (tabId === 'tabs-2') {
					$('#specificationsDiv').addClass('hidden');
				}
				else if (tabId === 'tabs-3') {
					$('#sustainabilityDiv').addClass('hidden');
				}
                else if (tabId === 'tabs-4') {
					$('#assemblyInstructionsDiv').addClass('hidden');
				}
			}
			tabsToProcess --;
			if(!tabsToProcess && tabsHavingContent.length){
				$('.product-details-page-accordion__container.hidden').remove();
				$("#tabContainer").removeClass("hidden");
			}
		},
		error: function(error){
			$('#assemblyInstructionsDiv').hide();
			$('#sustainabilityDiv').hide();
			$('#specificationsDiv').hide();
			$('#overviewDiv').hide();
		}
	});
	
}
}
